const {h, render, Component} = require('preact');

class ExternalDealNotesView extends Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
      <div class="notification warning twelve columns banner" data-bhw="web2018_external_deal_notes" dangerouslySetInnerHTML={{ __html: this.props.externalDealNotes}}/>
    );
  }
}
module.exports = ExternalDealNotesView
